import { render, staticRenderFns } from "./DialogFrame.vue?vue&type=template&id=6e1fa6a1&scoped=true"
import script from "./DialogFrame.vue?vue&type=script&lang=js"
export * from "./DialogFrame.vue?vue&type=script&lang=js"
import style0 from "./DialogFrame.vue?vue&type=style&index=0&id=6e1fa6a1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1fa6a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e1fa6a1')) {
      api.createRecord('6e1fa6a1', component.options)
    } else {
      api.reload('6e1fa6a1', component.options)
    }
    module.hot.accept("./DialogFrame.vue?vue&type=template&id=6e1fa6a1&scoped=true", function () {
      api.rerender('6e1fa6a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogFrame.vue"
export default component.exports